module.exports = __webpack_public_path__ + "static/media/twitter_icon.512536cb.png";